"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _heroBrand = _interopRequireDefault(require("../styles/hero-brand.css"));
var _heroBrand2 = _interopRequireDefault(require("./hero-brand.props/hero-brand.defaultProps"));
var _heroBrand3 = _interopRequireDefault(require("./hero-brand.props/hero-brand.propTypes"));
var _heroBackground = _interopRequireDefault(require("./hero-background"));
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;
var applyDarkTheme = function applyDarkTheme(data, theme) {
  return data.theme === 'dark' ? theme[data.theme] : '';
};
var HeroBrand = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(HeroBrand, _React$Component);
  function HeroBrand() {
    return _React$Component.apply(this, arguments) || this;
  }
  HeroBrand.resourceType = function resourceType() {
    return 'Standard_Hero_1_0_0';
  };
  var _proto = HeroBrand.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      market = _this$props.config.market,
      data = _this$props.data;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'hero_banner_view',
        comp_page: {
          name_banner: data && data.heading2 ? data.heading2.toLowerCase() : null,
          link: data && data.cta && data.cta.URL ? "" + (!/^(http|https):/.test(data.cta.URL) ? window.location.origin : '') + data.cta.URL : null
        }
      });
    }
    if (market.toLowerCase() === 'nl' && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        vehicleModel: data && data.heading2 ? data.heading2.toLowerCase() : null
      });
    }
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      data = _this$props2.data,
      theme = _this$props2.theme,
      defaultData = _this$props2.defaultData,
      config = _this$props2.config;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + applyDarkTheme(data, theme) + " " + _heroBrand["default"].heroContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _heroBrand["default"].heroWrapper + " " + (_heroBrand["default"][componentData.textBlockPosition] ? _heroBrand["default"][componentData.textBlockPosition] : '') + " " + theme.row
    }, /*#__PURE__*/_react["default"].createElement(_heroBackground["default"], {
      data: componentData,
      theme: theme,
      config: config
    })));
  };
  return HeroBrand;
}(_react["default"].Component);
HeroBrand.displayName = 'HeroBrand';
HeroBrand.defaultProps = {
  data: _heroBrand2["default"],
  defaultData: _heroBrand2["default"],
  config: {}
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(HeroBrand));
exports["default"] = _default;